import React from 'react'; 
// import PropTypes from 'prop-types';
import SectionHeader from '../../Basic/SectionHeader';
import TextBox from '../../Basic/TextBox';
import PhoneBox from '../../Enhanced/PhoneBox';
// import { connect } from 'react-redux';

class GasContractor extends React.Component {
    render() {
        const lookup = window.osa.lookup.optionalCustomerDetails.contractor;

        return (
            <div className="form-group">
                <SectionHeader title={lookup.title} />
                <br />
                <div className="row worksite_contact">
                    <div className="col-sm-4">
                        <TextBox name="contractorCompanyName" title="Company name" />
                    </div>
                    <div className="col-sm-4">
                        <TextBox name="contractorName" title="Contractor name" />
                    </div>
                </div>
                <br />
                <div className="row worksite_contact">
                    <div className="col-sm-4">
                        <PhoneBox name="contractorPrimaryPhone" title="Primary phone number" ext="1" />
                    </div>
                    <div className="col-sm-4">
                        <PhoneBox name="contractorSecondaryPhone" title="Secondary phone number" />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-12">
                        <p dangerouslySetInnerHTML={{ __html: lookup.needContractor }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default (GasContractor);